import React from "react";
import SettingsModal from "../../Modal/SettingsModal";
import QuestionnaireModal from "./QuestionnaireSettingsModal";
import Widget from "../../Widget/Widget";
import FormV3Controller from "../FormsV3/FormV3Controller";
import "./questionnaireWidgetStyle.less";
import IntlMessages from "../../../util/IntlMessages";
import clsx from "clsx";

type QuestionnaireValue = {
   id: string;
   name: string;
   questionnaireId?: string;
   backgroundColourHex?: string;
};

type Props = {
   value: QuestionnaireValue;
   role: string;
};

const QuestionnairePlaceholder: React.FC = () => (
   <div className="questionnaire-content-container">
      <div className="questionnaire-text-container">
         <h3 className="questionnaire-text-container__title">
            <IntlMessages id="questionnaireWidget.questionnaire" />
         </h3>
         <div className="questionnaire-text-container__sub-title">
            <IntlMessages id="questionnaireWidget.loadData" />
         </div>
      </div>
   </div>
);

const QuestionnaireWidget: React.FC<Props> = ({ value, role }) => {
   const hasQuestionnaireId = Boolean(value?.questionnaireId);
   const canEdit = role === "OWNER" || role === "MODERATOR";

   return (
      <div
         className={clsx(
            !hasQuestionnaireId ? "widget-questionnaire" : "widget-questionnaire full-width",
         )}
      >
         <Widget
            bgColor={value.backgroundColourHex}
            role={role}
            extra={
               canEdit && (
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     autoHeight
                  >
                     <QuestionnaireModal value={value} />
                  </SettingsModal>
               )
            }
         >
            {hasQuestionnaireId ? (
               <FormV3Controller formId={value.questionnaireId} isQuestionnaire />
            ) : (
               <QuestionnairePlaceholder />
            )}
         </Widget>
      </div>
   );
};

export default QuestionnaireWidget;
